module.exports = __webpack_public_path__ + "static/media/25-3.ac372f92.mp3";